/* src/app/admin/post-list/post-list.component.scss */
/*# sourceMappingURL=post-list.component-QREFWBQK.css.map */
